import { render, staticRenderFns } from "./SVGWavesLine.vue?vue&type=template&id=d074eb86&scoped=true&"
import script from "./SVGWavesLine.vue?vue&type=script&lang=js&"
export * from "./SVGWavesLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d074eb86",
  null
  
)

export default component.exports